<template>
  <div class="c-floating-counter">
    <div v-if="(actions || []).length" class="actions">
      <c-button
        flat
        flat-blur
        icon-size="24"
        class="action"
        v-for="{ name, icon, tooltip, color } in actions"
        v-tooltip:17.dark="{ value: tooltip, hide: !showTooltip || isMobile }"
        v-bind="{ [color ?? 'white']: true }"
        :icon="icon"
        :key="name"
        :data-testid="`floating-action-${name}`"
        @click.stop="$emit(`click:${name}`)"
      />
    </div>

    <div class="info">
      <c-counter
        v-bind="$attrs"
        class="counter"
        :value="count"
        :hasMinimumValue="shouldShowWarning"
        :hasEmptyValue="shouldShowEmpty"
      />

      <c-icon
        v-if="icon"
        class="icon"
        :icon="icon"
      />
    </div>
  </div>
</template>

<script>
import { MediaQuery } from '@convenia/mixins'

export default {
  name: 'CFloatingCounter',

  mixins: [ MediaQuery ],

  props: {
    count: {
      type: Number,
      default: 0
    },

    showTooltip: Boolean,

    actions: {
      type: Array,
      default: () => []
    },

    icon: {
      type: String,
      default: 'user-profile-3'
    },

    height: {
      type: String,
      default: '70px'
    },

    warningLevel: {
      type: Number,
      default: 0
    },

    hasEmptyValue: {
      type: Boolean,
      default: undefined
    },

    hasMinimumValue: {
      type: Boolean,
      default: undefined
    }
  },

  computed: {
    isCountEmpty () {
      return this.count == null || this.count <= 0
    },

    hasLowCount () {
      return this.count > 0 && this.count < this.warningLevel
    },

    shouldShowEmpty () {
      if (this.hasEmptyValue !== undefined) {
        return this.hasEmptyValue
      }
      return this.isCountEmpty
    },

    shouldShowWarning () {
      if (this.hasMinimumValue !== undefined) {
        return this.hasMinimumValue
      }
      return this.hasLowCount
    }
  },

  mounted () {
    this.$el.style.setProperty('--height', this.height)
  }
}
</script>

<style lang="scss">
.c-floating-counter {
  --height: 70px;

  height: var(--height);
  border-radius: calc(var(--height) / 2);
  background: linear-gradient(135deg, #3A4467, #121E48 100%);
  box-shadow: -1px -1px 4px 0 rgba(0,0,0,0.2);
  padding: 10px 15px;
  position: fixed;
  bottom: 20px;
  left: calc(50% + 35px);
  transform: translate(-50%);
  z-index: var(--z-index-2);

  @include responsive (tablet, desktop) {
    bottom: 40px;
  }

  &, & > .actions, & > .actions > .action {
    display: flex;
    align-items: center;
  }

  & > .actions > .action { margin-right: 10px; }

  & > .info {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;

    & > .icon {
      margin-left: 5px;
      @include icon-color(rgba(#FFF, .5));
    }
  }
}
</style>
